import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles(() => {
    return {
        seeDetailsButtonContainer: {
            display: 'flex' as const,
            justifyContent: 'center' as const,
            width: '100%',
            backgroundColor: '#fff',
            padding: '12px 0 10px 0'
        },
        seeDetailsButton: {
            width: '96px',
            height: '18px',
            padding: '12px auto 10px auto',
            color: '#FFF',
            textAlign: 'center' as const,
            fontSize: '9px'
        }
    };
});